import React from 'react'
import { Cell, Grid } from 'react-mdl'
import Button from '../../components/Button'
import ImageItem from './ImageItem'

const UnitScreen = ({
  unitImages,
  imageIds,
  handleImageSelect,
  images,
  goToPanel,
}) => (
  <div>
    <h3>Choose Images</h3>
    <div>
      <Grid style={{ overflowY: 'auto', maxHeight: '50vh' }}>
        {unitImages.map((imageId, i) => (
          <Cell key={i} col={6} onClick={handleImageSelect({ _id: imageId })}>
            <ImageItem _id={imageId} selected={imageIds.includes(imageId)} />
          </Cell>
        ))}
      </Grid>
    </div>
    <Cell col={12} style={{ display: 'flex' }}>
      <Button
        style={{ marginLeft: 'auto' }}
        disabled={images.length === 0}
        onClick={goToPanel('edit-images')}>
        Continue
      </Button>
    </Cell>
  </div>
)

export default UnitScreen



// WEBPACK FOOTER //
// ./src/components/ImageSelectionModal/UnitScreen.js